import React, { useMemo } from "react"
import PropTypes from "prop-types"
import { EmailPreview } from "@components/Text"
import { useAppContext } from "@components/AppContext"
import { useOutletContext } from "react-router-dom"

import renderContent from "./helpers/renderContent"


const EmailTemplatePreview = ({
  variables = undefined,
  extraContext = undefined,
  htmlTemplate = "",
  subjectTemplate = "",
}) => {
  const { identity } = useAppContext()
  const { project, accountsMap } = useOutletContext()

  const { organization } = identity
  const { emailFooterHtml: footerHtml } = organization

  let html = htmlTemplate

  const tagsMap = useMemo(() =>
    (variables || [])
      .sort((a, b) => a.localeCompare(b))
      .reduce((acc, pair) => {
        const [ variable, tag ] = pair.split(":")
        return { ...acc, [variable]: tag }
      }, {})
  , [ variables ])

  const account = Object.values(accountsMap)[0]
  const context = { project, organization, account, tagsMap, ...extraContext }

  if (footerHtml) {
    html += `\n${footerHtml}`
  }

  const renderedHtml = renderContent(html, context, false, variables)
  const renderedSubject = renderContent(subjectTemplate, context, true, variables)

  const emailHtml = `
    <h3 style="margin-bottom: 16px">
      ${renderedSubject}
    </h3>
    ${renderedHtml}
  `

  return (
    <EmailPreview html={emailHtml} />
  )
}

EmailTemplatePreview.propTypes = {
  variables: PropTypes.arrayOf(PropTypes.string),
  extraContext: PropTypes.shape(),
  htmlTemplate: PropTypes.string,
  subjectTemplate: PropTypes.string,
}

export default EmailTemplatePreview
